import { api } from '../../../../static/api-request/api';
import { Slot } from './interface';

export const getCompleteData = async (
  params?: Record<string, any>,
  headers?: HeadersInit,
) => {
  const queryParams = new URLSearchParams(params).toString();

  const endpoint = `/export/mp-content${queryParams ? `?${queryParams}` : ''}`;
  const defaultHeaders = {
    'x-functions-Key':
      process.env.LIVAT_APP_WRAPPER_FUNCTION_KEY ||
      process.env.GATSBY_LIVAT_APP_WRAPPER_FUNCTION_KEY ||
      '',
  };

  const mergedHeaders = {
    ...defaultHeaders,
    ...(headers || {}),
  };
  const response: any = api.get(endpoint, mergedHeaders);
  return response;
};

export const getSlots = async (
  params?: Record<string, any>,
): Promise<Slot[]> => {
  const queryParams = new URLSearchParams(params).toString();

  const endpoint = `/data/booking/event-details${
    queryParams ? `?${queryParams}` : ''
  }`;

  const response = await api.get<Slot[]>(endpoint, {
    'x-functions-Key':
      process.env.LIVAT_APP_WRAPPER_FUNCTION_KEY ||
      process.env.GATSBY_LIVAT_APP_WRAPPER_FUNCTION_KEY ||
      '',
    'X-Device-Platform': 'web',
    'X-Application-ID': 'Livat-web',
  });
  return response;
};

export const makeReservation = async (
  payload: any,
  params?: Record<string, any>,
  headers?: HeadersInit,
) => {
  const queryParams = new URLSearchParams(params).toString();

  const endpoint = `/data/booking/create${queryParams ? `?${queryParams}` : ''}`;

  const defaultHeaders = {
    'x-functions-Key':
      process.env.LIVAT_APP_WRAPPER_FUNCTION_KEY ||
      process.env.GATSBY_LIVAT_APP_WRAPPER_FUNCTION_KEY ||
      '',
    'X-Device-Platform': 'web',
    'X-Application-ID': 'Livat-web',
  };

  const mergedHeaders = {
    ...defaultHeaders,
    ...(headers || {}),
  };

  const response: any = await api.post(endpoint, payload, mergedHeaders);
  return response;
};
